import templateBase from './templates/category-pager-toolbox-base.view.html';
import template_t1 from './templates/category-pager-toolbox-t1.view.html';
import template_t11 from './templates/category-pager-toolbox-t11.view.html';

function MenuDirective(SessionService) {

  let response = SessionService.get('components');
  let htmlTemplate = templateBase;

  if (response.CATEGORY_PAGER_TOOLBOX.component == 'template_t1') {
    htmlTemplate = template_t1;
  } else if (response.CATEGORY_PAGER_TOOLBOX.component == 'template_t11') {
    htmlTemplate = template_t11;
  }

  return {
    restrict: 'E',
    template: htmlTemplate,
  };
}

MenuDirective.$inject = ['SessionService'];

export default MenuDirective;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/category/category-pager-toolbox/category-pager-toolbox.directive.js
 **/